/**
 * <s-age-gate> — 21+ acceptance prompt for alcohol pages.
 * Opens its <dialog> modally on connect unless the shopper already confirmed
 * this session. "Yes" stores acceptance; "No" sends the shopper to exit-url.
 * Escape cannot dismiss the prompt.
 *
 * Attributes:
 *   exit-url — where to send shoppers who answer no
 */
const KEY = 'gostore-age-21';

class SAgeGate extends HTMLElement {
  #ac;

  connectedCallback() {
    const dialog = this.querySelector('dialog');
    if (!dialog) return;
    let accepted = false;
    try { accepted = sessionStorage.getItem(KEY) === 'yes'; } catch (e) {}
    if (accepted) return;

    this.#ac = new AbortController();
    const { signal } = this.#ac;
    dialog.addEventListener('cancel', (event) => event.preventDefault(), { signal });
    this.querySelector('[data-age-yes]')?.addEventListener('click', () => {
      try { sessionStorage.setItem(KEY, 'yes'); } catch (e) {}
      dialog.close();
    }, { signal });
    this.querySelector('[data-age-no]')?.addEventListener('click', () => {
      window.location.href = this.getAttribute('exit-url') || '/';
    }, { signal });
    dialog.showModal();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-age-gate')) customElements.define('s-age-gate', SAgeGate);
